import { render, staticRenderFns } from "./AdicionarProduto.vue?vue&type=template&id=a7c66c6c&scoped=true&"
import script from "./AdicionarProduto.vue?vue&type=script&lang=js&"
export * from "./AdicionarProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c66c6c",
  null
  
)

export default component.exports